import { getInitialVisitRecievedCorrectiveImagesFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getRecievedCorrectiveImages/getInitialVisitRecievedCorrectiveImagesFunction';
import { GetRecievedCorrectiveParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getRecievedCorrectiveImages/getRecievedCorrectiveImages.type';
import { getRecievedCorrectiveImagesFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getRecievedCorrectiveImages/getRecievedCorrectiveImagesFunction';
import { queryOptions } from '@tanstack/react-query';

export const getRecievedCorrectiveImagesOptions = ({
  damaged_id,
  id,
  type,
}: GetRecievedCorrectiveParamsType) => {
  const reqFn = () => {
    if (type === 'initial') {
      return getInitialVisitRecievedCorrectiveImagesFunction({
        damaged_id,
        id,
        type,
      });
    }
    return getRecievedCorrectiveImagesFunction({ damaged_id, id });
  };
  return queryOptions({
    queryKey: ['GET_RECIEVED_CORRECTIVE_IMAGES_OPTIONS', damaged_id, id],
    queryFn: () => reqFn(),
  });
};
